import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import cache from "memory-cache";
import Locale from "./";
import getHeaderData from "../../lib/getHeaderData";

export default class About extends Component {
  constructor(props, staticContext) {
    super(props);
    let mobile;
    let refCode;
    const { initialData } = getHeaderData(staticContext, "user");
    if (initialData && initialData.ref) {
      refCode = initialData.ref.refCode;
    }
    //eslint-disable-next-line
    if (__isBrowser__) {
      mobile = isMobile;
    } else {
      mobile = cache.get("deviceType");
    }
    this.state = {
      ourStory: false,
      shareTheLove: false,
      joinUs: false,
      help: false,
      feedback: false,
      mobile,
      refCode
    };
  }
  handleChangeAboutSection = section => {
    let selectedSection = section.status || section;
    Object.keys(this.state).map(key => {
      this.setState({
        [key]: this.state[key]
      });
    });
    this.setState({
      [selectedSection]: !this.state[selectedSection]
    });
  };
  renderSelectedSection = () => {
    const {
      ourStory,
      help,
      shareTheLove,
      feedback,
      joinUs,
      mobile,
      refCode
    } = this.state;
    const { onCloseSection } = this.props;
    if (!mobile) {
      return <Locale.OurStory onCloseSection={this.handleChangeAboutSection} />;
    } else {
      if (ourStory) {
        return (
          <Locale.OurStory onCloseSection={this.handleChangeAboutSection} />
        );
      } else if (help) {
        return <Locale.Help onCloseSection={this.handleChangeAboutSection} />;
      } else if (shareTheLove) {
        return (
          <Locale.ShareTheLove
            onCloseSection={this.handleChangeAboutSection}
            refCode={refCode}
          />
        );
      } else if (feedback) {
        return (
          <Locale.Feedback onCloseSection={this.handleChangeAboutSection} />
        );
      } else if (joinUs) {
        return <Locale.JoinUs onClose={this.handleChangeAboutSection} />;
      } else {
        return (
          <div className="container">
            <div className="profile-desktop">
              {/* Header */}
              <div className="head-general with-back">
                <a
                  href="javascript: void(0)"
                  onClick={() =>
                    (onCloseSection && onCloseSection("localeSection")) ||
                    window.history.back()
                  }
                  className="back"
                >
                  <img src="/png/chevron-left.png" />
                </a>
                <h4>About Local E</h4>
                <a href="javascript: void(0)" className="close" />
              </div>
              {/* Header */}
              <h4 className="general-title hide-xs">About Local E</h4>
              <div className="white-bg padding-box mt-10px">
                <ul className="list-links">
                  <li onClick={() => this.handleChangeAboutSection("ourStory")}>
                    Our Story
                  </li>
                  {refCode && (
                    <li
                      onClick={() =>
                        this.handleChangeAboutSection("shareTheLove")
                      }
                    >
                      Share the love
                    </li>
                  )}

                  <li onClick={() => this.handleChangeAboutSection("joinUs")}>
                    Restaurant owner?
                  </li>
                  <li onClick={() => this.handleChangeAboutSection("help")}>
                    Help
                  </li>
                  <li onClick={() => this.handleChangeAboutSection("feedback")}>
                    Feedback
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      }
    }
  };
  render() {
    return this.renderSelectedSection();
  }
}
